import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Tab, Nav, NavItem, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SEO_PAGES, SEO_REDIRECTS, NAVIGATION, BUILDER, ACCESS_SOFTWARE_SETTINGS } from 'shared/abilities';
import Authorization from 'containers/Authorization';
import Icon from '../../../../../../modules/react/components/stateless/Icon';
import { AdminLayout, AdminHeader, AdminNavbar } from '../../../../layout';
import style from './AdminSettings.scss';

export default class AdminSettings extends React.Component {
  static propTypes = {
    pushRoute: PropTypes.func.isRequired,
    corporateUrl: PropTypes.string,
    domainSSLFlipper: PropTypes.bool,
    children: PropTypes.node,
  };

  static childContextTypes = {
    setTab: PropTypes.func,
  };

  static defaultProps = {};

  state = {
    tab: '',
  };

  getChildContext = () => ({
    setTab: tab => this.setState({ tab }),
  });

  handleTabSelect = (tab) => {
    this.props.pushRoute(`/admin/${tab}`);
  };

  renderNavItem = text => (authorized, newProps) => {
    const { eventKey, facilityIds, companyId, ...navItemProps } = newProps;
    return (
      <Nav.Item {...navItemProps} className={!authorized && style.unauthorized}>
        <Nav.Link eventKey={eventKey}>{text}</Nav.Link>
      </Nav.Item>
    );
  }

  render() {
    const { children, corporateUrl, domainSSLFlipper } = this.props;

    const tooltip = (
      <Tooltip id="advanced-settings">
        <span>
          You do not have permissions for Advanced Settings. Please contact support.
        </span>
      </Tooltip>
    );

    const header = (
      <AdminHeader title="Settings" />
    );

    const navbar = (
      <AdminNavbar settings={{ active: true }} />
    );

    return (
      <AdminLayout header={header} navbar={navbar}>
        <Helmet
          title="Settings"
        />
        <div className={style.root}>
          <div className={style.adminTabs}>
            <Tab.Container
              activeKey={this.state.tab}
              onSelect={this.handleTabSelect}
              id="settingsTabs"
              className={style.tabs}
            >
              <Nav variant="tabs" justified={false}>
                <Authorization action="manage" subject={[SEO_PAGES, BUILDER]} eventKey="settings/pages">
                  {this.renderNavItem('Page Settings')}
                </Authorization>
                <Authorization
                  action="manage"
                  subject={[NAVIGATION, BUILDER]}
                  eventKey="locales/en-us/navigation/edit"
                >
                  {this.renderNavItem('Navigation')}
                </Authorization>
                <NavItem>
                  <Nav.Link eventKey="settings/analytics">Analytics</Nav.Link>
                </NavItem>
                {!domainSSLFlipper && (
                  <Authorization action="manage" subject={BUILDER} eventKey="settings/domains">
                    {this.renderNavItem('Domains')}
                  </Authorization>
                )}
                { domainSSLFlipper && (
                  <Authorization action="manage" subject={BUILDER} eventKey="settings/domains-ssl">
                    {this.renderNavItem('Domains & SSL Certificates')}
                  </Authorization>
                )}
                <Authorization action="manage" subject={[SEO_REDIRECTS, BUILDER]} eventKey="settings/redirects">
                  {this.renderNavItem('Redirects')}
                </Authorization>
                {!domainSSLFlipper && (
                  <Authorization action="manage" subject={BUILDER} eventKey="settings/ssl">
                    {this.renderNavItem('SSL Certificates')}
                  </Authorization>
                )}
                <Authorization action="manage" subject={[SEO_PAGES, BUILDER]} eventKey="settings/robots">
                  {this.renderNavItem('robots.txt')}
                </Authorization>
              </Nav>
            </Tab.Container>
            <Authorization action="manage" subject={ACCESS_SOFTWARE_SETTINGS} eventKey="website-settings">
              {(authorized) => {
                const button = (
                  <Button
                    variant="primary"
                    disabled={!authorized}
                    className={style.linkToUpButton}
                    href={`${corporateUrl}/settings/website`}
                  >
                    <span className={style.advButtonText}>Advanced Settings</span>
                    <Icon id="external-link" label="Advanced Settings Linkout" />
                  </Button>
                );

                if (authorized) {
                  return button;
                }

                return (
                  <OverlayTrigger
                    placement="left"
                    overlay={tooltip}
                    trigger={['hover', 'focus']}
                  >
                    <span>{button}</span>
                  </OverlayTrigger>
                );
              }}
            </Authorization>
          </div>
          <div className={style.container}>
            {children}
          </div>
        </div>
      </AdminLayout>
    );
  }
}
